import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import * as yup from 'yup';
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import Button from '../../../components/Button'
import '../../../assets/languages/i18n'
import { Box, Grid, Link, Paper, TextField, Toolbar, Typography, InputAdornment, Alert, FormHelperText } from "@mui/material";
import { Formik, useFormik } from "formik";
import LoginBG from "../../../../src/assets/images/bg.svg"
import LoginLogo1 from "../../../../src/assets/images/login/design-stats-pana-1.png"
import UnderConLogo from "../../../../src/assets/images/login/under-construction.png"
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from 'react-cookie';
import { makeStyles } from "@mui/styles";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "../../../assets/images/closeLogin.svg";
import { ReactComponent as VerifyMail } from "../../../assets/images/forgotpwd/VerifyMail.svg";
import { ReactComponent as VerifyUser } from "../../../assets/images/forgotpwd/VerifyUser.svg";
import authService from "../../../services/auth.service";

const styles = {
    toolBar: {
        paddingLeft: "5px",
    },
    childToolBar: {
        padding: "32px 20px",
        fontWeight: '400'
    },
    title: {
        paddingBottom: "15px"
    },
    subTitle: {
        color: "#282C40 !important"
    },
};

const useStyles = makeStyles({
    error: {
        color: " #CC6058!important",
        "& div > .MuiFormHelperText-root": {
            color: " #CC6058 !important",
            fontSize: "14px",
            lineHeight: "15.4px",
            marginLeft: 0,
        },
        "& > .MuiFormHelperText-root": {
            color: " #CC6058 !important",
            fontSize: "14px",
            lineHeight: "15.4px",
            marginLeft: 0,
        },
        "& div > input": {
            fontSize: "14px",
            lineHeight: "15.4px",
        },
        "& div > label": {
            color: "#0C2B34",
            fontSize: "16px",
            lineHeight: "17.6px",
            fontWeight: "500"
        },
    },
    expire: {
        paddingRight: "20px"
    }
});

const ForgotPassword = () => {
    // getData();
    const [cookies, setCookie] = useCookies(['member']);
    const classes = useStyles()
    const navigate = useNavigate();
    const { t } = useTranslation()
    let { site } = useParams()
    const dispatch = useDispatch();
    const Start = useSelector((state) => state.Start);
    const [startTime, setStartTime] = useState(false);

    useEffect(() => {
        if (Start.recaptchaKey === "") {
            //navigate('/' + site, { replace: false });
            window.location.href = '/' + localStorage.getItem("site")
        }
    }, [Start]);

    useEffect(() => {
        document.getElementById('signin').style.display = "none"
    }, []);

    const [showPassword, setShowPassword] = useState(false);
    const [checkExpire, setCheckExpire] = useState(false);
    const [checkEmail, setCheckEmail] = useState(true);
    const [checkDup, setCheckDup] = useState();
    const [Texts, setText] = useState("");
    const [submitForgot, setSubmitForgot] = useState(false);
    const [checkUsername, setCheckUsername] = React.useState(false);
    const [userLocked, setUserLocked] = useState(false);
    const [TextsError, setTextsError] = useState("");

    const startTimer = (duration) => {
        setStartTime(true)
        var timer = 60;
        let time = setInterval(function () {
            document.getElementById("time").innerHTML = " (" + timer + " Sec)";
            console.log(timer);
            timer--
            if (timer < 0) {
                clearInterval(time)
                setStartTime(false)
                document.getElementById("time").innerHTML = ""
            }
        }, 1000);
    }

    const handleClick = () => {
        setShowPassword(prev => !prev);
    }
    const handleClose = () => {
        setCheckExpire(false)
        setCheckDup("")
    }

    const onClickSubmit = () => {
        let dt = {
            user: "",
            username: formik.values.username,
            pincode: "",
            new_password: "",
            options: {}
        }
        authService.forgetPassword(dt).then((rs) => {
            if (rs?.success === true) {
                console.log(rs);
                setCheckEmail(true)
                setSubmitForgot(true)
                startTimer();
                setCheckUsername(false)
                setUserLocked(false)
            } else {
                setCheckEmail(false)
                setSubmitForgot(true)
            }
        }).catch((err) => {
            console.log(err);
            if (err?.data?.code === "user.msg.user_not_found") {
                setCheckUsername(true)
            } else {
                setCheckUsername(false)
            }
            if (err?.data?.code === "user.msg.user_locked") {
                setUserLocked(true)
                setTextsError(t('login.msg.user_locked'));
            }
            if (err?.data?.code === "login.msg.email_notfound") {
                setCheckEmail(false)
                setSubmitForgot(true)
            }
        })

    }

    let confirmAgian = () => {
        onClickSubmit();
    }
    const onClickVerifyMail = () => {
        setSubmitForgot(false)

    }
    const acceptLogin = (data) => {
        navigate(data, { replace: false });
    }

    const formik = useFormik({
        initialValues: {
            username: "",
        },
        enableReinitialize: true,
        validationSchema: yup.object().shape({ username: yup.string().required(t('login.msg.specify_username')) }),
        onSubmit: (values) => {
            onClickSubmit(values)
        },
    });

    return (
        <>
            <Helmet>
                <title>Login | PMS</title>
            </Helmet>
            <Grid container sx={{
                height: '100%',
                'min-height': "600px",
                'backgroundImage': `url(${LoginBG})`,
                'background-size': 'cover',
            }}>
                <Grid container item
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', lg: 'row' },
                        alignItems: 'center',
                        overflow: 'hidden',
                        boxShadow: 0,
                        fontWeight: 'bold',
                    }}>
                    <Grid container item xs={12} lg={6} justifyContent="center"
                        sx={{ display: { sm: 'none', lg: 'flex' } }} alignItems="center">
                        <img src={LoginLogo1} style={{ maxHeight: "485px" }} />
                    </Grid>
                    <Grid container item xs={12} lg={6} spacing={4} sx={{}}>
                        {userLocked ? (
                            <Grid container item>
                                <Grid item sx={{ maxWidth: "477px", width: "100%", }}>
                                    <Alert
                                        icon={false}
                                        sx={{
                                            color: "#CC6058",
                                            background: "#FFE9E8",
                                            borderRadius: "5px",
                                            position: "relative",
                                            "box-shadow": "0px 2px 10px rgba(0, 0, 0, 0.1)",
                                            ".MuiAlert-message": {
                                                textAlign: "center",
                                                width: "100%",
                                            }
                                        }}
                                    >
                                        <Typography
                                            fontSize={14}
                                            lineHeight="19.12px"
                                            fontWeight={500}
                                        // classes={{ root: classes.expire }}
                                        >
                                            {TextsError}
                                        </Typography>
                                    </Alert>
                                </Grid>
                            </Grid>
                        ) : null}
                        <Grid direction="column" sx={{}}
                            container item
                            justifyContent="center"
                            alignItems="center">
                            {Start?.data?.configuration?.maintenance ?
                                (<Grid container item>
                                    <Grid container item sx={{}}>
                                        <Paper elevation={6} sx={{ padding: '50px' }}>
                                            <img src={UnderConLogo} />
                                            <Typography variant="h1" align="center">{t('login.msg.underconMsg1')}</Typography>
                                            <Typography align="center" color="#C4C4C4">{t('login.msg.underconMsg2')}</Typography>
                                        </Paper>
                                    </Grid>
                                </Grid>)
                                :
                                (<Grid container item>
                                    {
                                        submitForgot ?
                                            checkEmail ?
                                                <Paper elevation={6} sx={{ padding: '50px', 'borderRadius': '20px', width: '100%', maxWidth: '480px', minHeight: '485px' }}>
                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                        <VerifyMail />
                                                    </Box>
                                                    <Grid justifyContent="center" display="flex" flexDirection="column" alignItems="center">
                                                        <Typography
                                                            color="primary"
                                                            variant="h2"
                                                            paddingTop="20px"
                                                            style={styles.title}
                                                            fontSize={36}
                                                            lineHeight="39.6px"
                                                        >
                                                            {t('forgotpwd.label.verifyMail')}
                                                        </Typography>
                                                        <Typography sx={{ width: '90%', margin: '0 auto', 'text-align': 'center' }}
                                                            pb="20px"
                                                            paddingTop="7px"
                                                            fontSize={14}
                                                            lineHeight="21.86px"
                                                        >
                                                            {t('forgotpwd.label.sendmMail')}
                                                        </Typography>
                                                    </Grid>
                                                    <Button
                                                        color="primary"
                                                        fullWidth
                                                        size="large"
                                                        type="submit"
                                                        variant="contained"
                                                        sx={{ fontSize: '18px', textTransform: 'none' }}
                                                        onClick={() => acceptLogin('/')}
                                                    >
                                                        {t('forgotpwd.label.goToLogin')}
                                                    </Button>
                                                    <Grid justifyContent="center" display="flex" flexDirection="column" alignItems="center" pt="28px">
                                                        <Typography
                                                            fontSize={14}
                                                            lineHeight="21.86px"
                                                        >
                                                            {t('forgotpwd.label.confirmMail')}
                                                        </Typography>
                                                        <Typography

                                                            fontSize={14}
                                                            lineHeight="21.86px"
                                                        >
                                                            {t('forgotpwd.label.or')}
                                                            <span style={{ textDecoration: 'underline', color: '#5DA196', cursor: startTime ? "" : 'pointer' }} onClick={startTime ? null : confirmAgian} >
                                                                {t('forgotpwd.label.confirmAgian')}
                                                            </span>
                                                            <span id="time" style={{ color: '#5DA196' }} onClick={startTime ? null : confirmAgian}></span>
                                                        </Typography>
                                                    </Grid>
                                                </Paper> //step2 ตรวจสอบ mail
                                                :
                                                <Paper elevation={6} sx={{ padding: '50px', 'borderRadius': '20px', width: '100%', maxWidth: '480px', minHeight: '485px' }}>
                                                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                                                        <VerifyUser />
                                                    </Box>
                                                    <Grid justifyContent="center" display="flex" flexDirection="column" alignItems="center">
                                                        <Typography
                                                            color="#EFB76D"
                                                            variant="h2"
                                                            paddingTop="20px"
                                                            style={styles.title}
                                                            fontSize={36}
                                                            lineHeight="39.6px"
                                                            dangerouslySetInnerHTML={{ __html: t('forgotpwd.label.verifyUser') }}
                                                        >
                                                        </Typography>
                                                        <Typography
                                                            pb="25px"
                                                            textAlign="center"
                                                            paddingTop="10px"
                                                            fontSize={16}
                                                            lineHeight="21.86px"
                                                            dangerouslySetInnerHTML={{ __html: t('forgotpwd.label.verifyMailUser') }}
                                                        >
                                                        </Typography>
                                                    </Grid>
                                                    <Button
                                                        color="primary"
                                                        fullWidth
                                                        size="large"
                                                        type="submit"
                                                        sx={{ fontSize: '18px', textTransform: 'none' }}
                                                        variant="contained"
                                                        onClick={() => onClickVerifyMail()}
                                                    >
                                                        {t('forgotpwd.label.goToResetPwd')}
                                                    </Button>
                                                </Paper> //step2 ตรวจสอบ mail Your e-mail is not found
                                            :
                                            <Paper elevation={6} sx={{ padding: '50px', 'borderRadius': '20px', width: '100%', maxWidth: '480px', minHeight: '485px' }} classes={{ root: classes.error }}>
                                                <Box sx={{ paddingTop: "0 !important", ".MuiFormControl-root": { marginTop: "7px", marginBottom: "0" }, }}>
                                                    <Box sx={{ mb: 3 }}>
                                                        <Typography
                                                            color="primary"
                                                            variant="h2"
                                                            style={styles.title}
                                                            fontSize={36}
                                                            lineHeight="39.6px"
                                                        >
                                                            {t('forgotpwd.label.resetpwd')}
                                                        </Typography>
                                                        <Typography
                                                            color="#C4C4C4"
                                                            gutterBottom
                                                            variant="h2"
                                                            fontSize={16}
                                                            fontWeight={300}
                                                            lineHeight="17.6px"
                                                        >
                                                            {t('forgotpwd.label.signinDesc')}
                                                        </Typography>
                                                    </Box>
                                                    <Typography color="#404349" fontSize={18} fontWeight={500} lineHeight="19.8px">{t("login.label.username")}</Typography>
                                                    <TextField
                                                        error={Boolean(formik.touched.username && formik.errors.username) === false ? checkUsername === true ? true : false : true}
                                                        fullWidth
                                                        helperText={formik.touched.username && formik.errors.username}
                                                        margin="normal"
                                                        name="username"
                                                        onBlur={formik.handleBlur}
                                                        onChange={formik.handleChange}
                                                        type="text"
                                                        value={formik.values.username}
                                                        variant="standard"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        placeholder={t("login.label.holderUsername")}
                                                    />
                                                    {Boolean(formik.touched.username && formik.errors.username) === false && checkUsername === true ? (<FormHelperText error >{t('forgotpwd.msg.usernameIsInvalid')} </FormHelperText>) : <></>}
                                                    <Button sx={{ marginTop: '40px', textTransform: 'none' }}
                                                        color="primary"
                                                        disabled={formik.values.username === ""}
                                                        fullWidth
                                                        size="large"
                                                        type="submit"
                                                        variant="contained"
                                                        onClick={formik.submitForm}
                                                    >
                                                        {t('label.confirm')}
                                                    </Button>
                                                    <Typography sx={{ textDecoration: 'underline', justifyContent: "center", cursor: 'pointer' }}
                                                        color="#A0A0A0"
                                                        fontSize={15}
                                                        lineHeight="21.86px"
                                                        textAlign="center"
                                                        paddingTop="20px"
                                                        onClick={() => acceptLogin('/')}
                                                    >
                                                        {t('forgotpwd.label.goToLogin')}
                                                    </Typography>
                                                    <Typography
                                                        color="#A0A0A0"
                                                        gutterBottom
                                                        variant="h2"
                                                        textAlign="center"
                                                        paddingTop="40px"
                                                        fontSize={14}
                                                        fontWeight={300}
                                                        lineHeight="20.93px"
                                                    >
                                                        {t('forgotpwd.label.verifyAccount')}
                                                    </Typography>
                                                    <Typography
                                                        color="#A0A0A0"
                                                        gutterBottom
                                                        variant="h2"
                                                        textAlign="center"
                                                        fontSize={14}
                                                        fontWeight={300}
                                                        lineHeight="20.93px"
                                                    >
                                                        {t('forgotpwd.label.contactHR')}
                                                    </Typography>
                                                </Box>
                                            </Paper > //step1 กรอก email
                                    }
                                </Grid >)}
                            <Grid container item sx={{}}>
                            </Grid>
                        </Grid >
                    </Grid >
                </Grid >
                <Grid container item sx={{
                    bottom: 0
                }}
                >
                    <Toolbar color="primary" sx={{ 'align-items': 'end', 'padding-left': '5px' }} style={styles.toolBar}>
                        <Typography variant="h6" component="div" sx={{ flexGrow: 0 }} p={4} style={styles.childToolBar}>
                            Copyright 2021 I AM Consulting Co., Ltd. All Rights Reserved
                        </Typography>
                    </Toolbar>

                </Grid>
            </Grid >
        </>
    );
};
export default ForgotPassword;
